import styled, { css } from "styled-components";

export const ContactContainerOuter = styled.div`
  margin-top: 1.2rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const ContactContainerInfo = styled.section`
  display: flex;
  flex-direction: column;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const OuterWrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props?.column ?? "20% 60% 20%"};
  font-weight: bold;
  margin-bottom: 15px;
`;

export const ContactInfoOuter = styled.div`
  display: block;
`;

export const ContactInfo = styled.div`
  justify-self: auto;
  color: ${(props) => props?.color ?? "#767676"};
  font-size: ${(props) => props?.fontSize ?? "14px"};
  font-weight: bold !important;
  padding-left: 4px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
`;
